// Translations for signature complete page
export const T = {
  en_GB: {
    documentsSigned: "Documents Signed!",
    signatureRecorded: "Your signature has been successfully recorded",
    thankYou: "Thank you,",
    documentsSecurelyStored:
      "Your signed documents have been securely stored and your advisor will be notified.",
    signatureEvidenceRecorded: "Signature Evidence Recorded",
    dateAndTime: "Date and time of signing",
    authMethodVerified: "Authentication method verified",
    contactInfoConfirmed: "Contact information confirmed",
    digitalSignatureStored: "Digital signature stored securely",
    whatHappensNext: "What happens next?",
    advisorWillProcess: "Your advisor will process the signed documents",
    receiveCopies: "You may receive copies via email",
    legallyBinding: "The documents are legally binding and securely stored",
    closeWindow: "You can now close this window.",
  },
  nb_NO: {
    documentsSigned: "Dokumenter signert!",
    signatureRecorded: "Signaturen din er registrert",
    thankYou: "Takk,",
    documentsSecurelyStored:
      "De signerte dokumentene er sikkert lagret og rådgiveren din vil bli varslet.",
    signatureEvidenceRecorded: "Signaturbevis registrert",
    dateAndTime: "Dato og tid for signering",
    authMethodVerified: "Autentiseringsmetode bekreftet",
    contactInfoConfirmed: "Kontaktinformasjon bekreftet",
    digitalSignatureStored: "Digital signatur lagret sikkert",
    whatHappensNext: "Hva skjer videre?",
    advisorWillProcess: "Rådgiveren din vil behandle de signerte dokumentene",
    receiveCopies: "Du kan motta kopier via e-post",
    legallyBinding: "Dokumentene er juridisk bindende og sikkert lagret",
    closeWindow: "Du kan nå lukke dette vinduet.",
  },
} as const;
